export default {
  conversations: [],
  conversation: null,
  messages: [],
  templates: [],
  pagination: { next_cursor: null, has_more: false, total: 0 },
  sessionActive: false,
  sessionExpiresAt: null,
  loading: false
}
